import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/core-api/api-client-util/src/hooks/useFetch/useFetch.ts");
;
import(/* webpackMode: "eager", webpackExports: ["CookieManagerContext"] */ "/app/libs/environment/cookies-util/src/context/cookie-manager-context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/environment/cookies-util/src/context/cookie-manager-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/environment/environment-util/src/EnvsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/help-center-support-tickets/help-center-support-tickets-feature/src/SupportTickets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/libs/shared/ui-helpers/src/components/JsonLd/JsonLd.tsx");
